var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{staticClass:"ma-0",attrs:{"justify":"center"}},[_c('manual-upload-form')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }